import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3nkm1llvx0: FaireBrandEntity = {
  token: "b_3nkm1llvx0",
  type: "brand",
  name: "Bat Flower Press",
  avatarUrl:
    "https://cdn.faire.com/fastly/1e39fcc98729259cae469617383fb4770da95b4d1666f2a9da7701e4b0db9054.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/943ebf59300f24d71a61f9cafe587b302dd414a8ceff5902056499f1bf15138c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1e39fcc98729259cae469617383fb4770da95b4d1666f2a9da7701e4b0db9054.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/943ebf59300f24d71a61f9cafe587b302dd414a8ceff5902056499f1bf15138c.jpeg",
  location: "Tarrytown, NY, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 20,
  isTopShop: true,
  isInsider: true,
  description:
    "Natalia Woodward is a Tarrytown based artist, maker and entrepreneur. Hailing from Pereira, Colombia, Natalia moved to New York in 2007 and graduated from SUNY Purchase with a BFA in Printmaking.  Through her drawings, prints, and paper collages she explores the natural world in all of its unseen connections.  \n\nIn 2020, Natalia founded Bat Flower Press, a letterpress and papermaking studio that focuses on sustainable handmade paper and artistic letterpress designs. Having worked with high end art collectors and organizations such as NY’s MoMA, Natalia has spent her career around precious artwork, and sees Bat Flower Press as an opportunity to bridge art and functionality, to collaborate with others, and to create meaningful work that is approachable to all. \nAs a sustainably minded individual, papermaking has always been a goal of hers. Oftentimes, the most sought after natural fiber paper comes from the other side of the world. Natalia hopes that by working with local farms & businesses, she can continue to push the envelope of sustainable papermaking by using unique local materials that would otherwise be waste.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:46.832Z",
    importedBy: "entity-db-cli",
  },
};
